import { useState } from 'react';
import type { UserDetailsResponse } from '../../schemas/validation';

export interface UserDetailsState {
  userDetails: UserDetailsResponse['data'] | null;
  setUserDetails: (details: UserDetailsResponse['data'] | null) => void;
  loading: boolean;
  setLoading: (loading: boolean) => void;
  error: string | null;
  setError: (error: string | null) => void;
  showOverrideForm: boolean;
  setShowOverrideForm: (show: boolean) => void;
  overrideMaxSites: string;
  setOverrideMaxSites: (value: string) => void;
  overrideMaxPagesPerSite: string;
  setOverrideMaxPagesPerSite: (value: string) => void;
  overridePrice: string;
  setOverridePrice: (value: string) => void;
  hasActiveSubscription: boolean;
  setHasActiveSubscription: (value: boolean) => void;
  billingPeriod: string | null;
  setBillingPeriod: (value: string | null) => void;
  currentPlanPrice: number | null;
  setCurrentPlanPrice: (value: number | null) => void;
  hasCustomPrice: boolean;
  setHasCustomPrice: (value: boolean) => void;
  planName: string | null;
  setPlanName: (value: string | null) => void;
  savingOverrides: boolean;
  setSavingOverrides: (saving: boolean) => void;
  overrideSuccess: string | null;
  setOverrideSuccess: (message: string | null) => void;
  overrideError: string | null;
  setOverrideError: (error: string | null) => void;
}

export const useUserDetailsState = (): UserDetailsState => {
  const [userDetails, setUserDetails] = useState<UserDetailsResponse['data'] | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [showOverrideForm, setShowOverrideForm] = useState(false);
  const [overrideMaxSites, setOverrideMaxSites] = useState<string>('');
  const [overrideMaxPagesPerSite, setOverrideMaxPagesPerSite] = useState<string>('');
  const [overridePrice, setOverridePrice] = useState<string>('');
  const [hasActiveSubscription, setHasActiveSubscription] = useState(false);
  const [billingPeriod, setBillingPeriod] = useState<string | null>(null);
  const [currentPlanPrice, setCurrentPlanPrice] = useState<number | null>(null);
  const [hasCustomPrice, setHasCustomPrice] = useState(false);
  const [planName, setPlanName] = useState<string | null>(null);
  const [savingOverrides, setSavingOverrides] = useState(false);
  const [overrideSuccess, setOverrideSuccess] = useState<string | null>(null);
  const [overrideError, setOverrideError] = useState<string | null>(null);

  return {
    userDetails,
    setUserDetails,
    loading,
    setLoading,
    error,
    setError,
    showOverrideForm,
    setShowOverrideForm,
    overrideMaxSites,
    setOverrideMaxSites,
    overrideMaxPagesPerSite,
    setOverrideMaxPagesPerSite,
    overridePrice,
    setOverridePrice,
    hasActiveSubscription,
    setHasActiveSubscription,
    billingPeriod,
    setBillingPeriod,
    currentPlanPrice,
    setCurrentPlanPrice,
    hasCustomPrice,
    setHasCustomPrice,
    planName,
    setPlanName,
    savingOverrides,
    setSavingOverrides,
    overrideSuccess,
    setOverrideSuccess,
    overrideError,
    setOverrideError,
  };
};
